<template>
  <div
    ref="leftCodeBox"
    class="code-box scroll_bar_beautify_ff"
  >
    <div
      ref="codeForm"
      class="code-form"
      :class="{'view-hover': type === 'viewStyle'}"
    >
      <template v-if="datasReady">
        <draggable
          v-model="myList"
          @end="dragEndHandle"
        >
          <code-item
            v-for="(item, index) in myList"
            :key="item.fieldkey"
            :item-data="item"
            :index="index"
          />
        </draggable>
        <div
          v-if="!!deployDatas.config.need_captcha"
          class="f-item-row"
        >
          <div class="f-item-label">
            {{ $t('message["1433"]') }}：
          </div>
          <div class="f-item-cell">
            <div class="valid-code">
              <img src="../../../assets/images/valid.png">
            </div>
          </div>
        </div>
        <div
          class="f-item-row f-item-row-btn"
          :class="{'borderCl': isBorder}"
          @click="getData"
        >
          <div class="f-item-cell">
            <button
              type="submit"
              disabled
              class="sub-btn"
            >
              {{ deployDatas.config.submit_text }}
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import CodeItem from './CodeItem'
import { mapState, mapMutations } from 'vuex'
// import Draggable from 'vuedraggable'
import eventBus from '@/lib/eventBus'
import { getH } from '@/store/universalForm/convert'
export default {
  components: {
    CodeItem
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      active: false
    }
  },
  computed: {
    ...mapState('universalForm/form', ['formDefaultDatas', 'deployDatas', 'isBorder', 'datasReady']),
    myList: {
      get () {
        return this.formDefaultDatas
      },
      set (value) {
        // this.$store.commit('UPDATE_RESULT', value)
        this.setFormDefaultDatas(value)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      let $main = this.$refs.leftCodeBox
      // $main.style.height = window.innerHeight - 56 - 58 - 45 - 48 + 'px'
      // $main.style.overflow = 'hidden'
      getH($main, 210)
    })
  },
  methods: {
    ...mapMutations('universalForm/form', ['setFormDefaultDatas', 'setIsBorder']),
    getData () {
      this.formDefaultDatas.forEach((item) => {
        item.isActive = false
      })
      this.setIsBorder(true)
      eventBus.$emit('getItemData', this.isBorder)
    },
    dragEndHandle ({ oldIndex, newIndex }) {
    }
  }
}
</script>
<style lang="scss" scoped>
.code-box::v-deep {
  // .item-row:after {
  //   clear: both;
  //   content: '.';
  //   display: block;
  //   height: 0;
  //   visibility: hidden;
  // }
  // .item-row {
  //   padding:12px 0 12px 180px;
  //   border-radius: 4px;
  //   .item-label {
  //     float: left;
  //     width: 170px;
  //     margin-left: -180px;
  //     text-align: right;
  //     height: 32px;
  //     line-height: 32px;
  //     .need-tip {
  //       color: #f57676;
  //     }
  //   }
  //   .item-cell {
  //     float: left;
  //     width: 100%;
  //     .input-text {
  //       border: 1px solid #d6d6d6;
  //       border-radius: 4px;
  //       height: 32px;
  //       line-height: 32px;
  //       width: 320px;
  //       padding: 3px;

  //     }
  //     [disabled] {
  //       background: #f5f5f5;
  //       cursor:no-drop;
  //     }
  //     ::-webkit-input-placeholder{
  //       color:#ebebeb;
  //     }
  //     ::-moz-placeholder {
  //       color:#ebebeb;
  //     }
  //     :-ms-input-placeholder {
  //       color:#ebebeb;
  //     }
  //   }
  // }
  overflow-y: auto;

  .f-item-row:hover {
    background: #f4f7f9;
    cursor: pointer;
    .f-item-label {
      cursor: pointer;
    }
  }
  .borderCl {
    border: 1px solid #5077aa;
    background: #f4f7f9;
  }
  .view-hover {
    .f-item-row {
      .iconfont {
        display: none !important;
      }
    }
    .f-item-row:hover {
      background: none;
    }
    .borderCl {
      border: 0 none;
      background: none;
    }
  }
}
</style>
